'use strict';

module.exports = function () {
  throw new Error(
    'ws does not work in the browser. Browser clients must use the native ' +
      'WebSocket object'
  );
};



//////////////////
// WEBPACK FOOTER
// ./~/ws/browser.js
// module id = 1035
// module chunks = 42